import React, { useEffect, useState } from 'react'
import BigModal from '../../../../components/Modals/BigModal'
import { LinearProgress, Stack, Typography } from '@mui/material'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import API from '../../../../services/API'
import { isFullWidth } from 'validator'

const EMPTemplateViewer = ({ viewTemplate, setViewTemplate }) => {
  const [loading, setLoading] = useState({})
  const [template, setTemplate] = useState({})

  useEffect(() => {
    viewTemplate &&
      API.get(`/admin/emptemplate/${viewTemplate._id}`)
        .then((res) => res.status === 200 && setTemplate(res.data))
        .finally(() => setLoading(false))
  }, [viewTemplate])

  return (
    <BigModal
      autoWidth
      open={!!viewTemplate}
      onClose={() => setViewTemplate(null)}
    >
      <Stack gap={1}>
        <Typography variant="title2">{viewTemplate?.title}</Typography>
        {loading && <LinearProgress />}
        <DetailsBox
          title="Operational Plan"
          rows={Object.keys(template?.opsPlan || []).map((x) => ({
            label: x,
            value: template?.opsPlan?.[x] ?? '',
            fullWidth: true,
          }))}
          fullWidthLabels
        />
        <DetailsBox
          title="Risk Assessment"
          rows={Object.keys(template?.riskAssessment || []).map((x) => ({
            label: x,
            value: template?.riskAssessment?.[x] ?? '',
            fullWidth: true,
          }))}
          fullWidthLabels
        />
        <DetailsBox
          title="Clinical Considerations"
          rows={Object.keys(template?.medPlan || []).map((x) => ({
            label: x,
            value: template?.medPlan?.[x] ?? '',
            fullWidth: true,
          }))}
          fullWidthLabels
        />
      </Stack>
    </BigModal>
  )
}

export default EMPTemplateViewer
